<template>
  <div class="scene-hospital-mobile" :class="classList">

    <MapObject class="scene-hospital-mobile__trees" src="/map/mobile_hospital_trees.png" type="trees" :animated="ready"></MapObject>
    <MapObject class="scene-hospital-mobile__hospital" src="/map/hospital.png" type="building" :animated="ready"></MapObject>

    <MapObject class="scene-hospital-mobile__b1" src="/map/build_8f_1.png" type="building" :animated="ready"></MapObject>
    <MapObject class="scene-hospital-mobile__b2" src="/map/build_8f_1.png" type="building" :animated="ready"></MapObject>
    <MapObject class="scene-hospital-mobile__b3" src="/map/build_2f_2.png" type="building" :animated="ready"></MapObject>
    <MapObject class="scene-hospital-mobile__b4" src="/map/build_4f_long_left.png" type="building" :animated="ready"></MapObject>
    <MapObject class="scene-hospital-mobile__b5" src="/map/build_4f_long_left.png" type="building" :animated="ready"></MapObject>
    <MapObject class="scene-hospital-mobile__b6" src="/map/build_8f_2.png" type="building" :animated="ready"></MapObject>
    <MapObject class="scene-hospital-mobile__b7" src="/map/build_4f_long_2.png" type="building" :animated="ready"></MapObject>
    <MapObject class="scene-hospital-mobile__b8" src="/map/build_4f_long_2.png" type="building" :animated="ready"></MapObject>

  </div>
</template>

<script>
  import Scene from './Scene.vue'

  export default {
    extends: Scene,
  }
</script>

<style lang="scss">
  .scene-hospital-mobile {
    @include relative-units(383.76px, 383px, mobile)
  }

  .scene-hospital-mobile__trees {
    top: 11%;
    left: 0;
    width: 100%;
  }
  .scene-hospital-mobile__hospital {
    top: 18.2%;
    left: 23%;
    width: 73.6%;
  }
  .scene-hospital-mobile__b1 {
    left: 35%;
    top: 0%;
    width: 12%;
  }
  .scene-hospital-mobile__b2 {
    left: 23%;
    top: 5.7%;
    width: 12%;
  }
  .scene-hospital-mobile__b3 {
    left: 9%;
    top: 16.6%;
    width: 15%;
  }
  .scene-hospital-mobile__b4 {
    left: 12.5%;
    top: 63%;
    width: 18%;
  }
  .scene-hospital-mobile__b5 {
    left: 1%;
    top: 69.5%;
    width: 18%;
  }
  .scene-hospital-mobile__b6 {
    left: 88.2%;
    top: 50.4%;
    width: 12%;
  }
  .scene-hospital-mobile__b7 {
    left: 70.8%;
    top: 60%;
    width: 19.5%;
  }
  .scene-hospital-mobile__b8 {
    left: 41%;
    top: 80.5%;
    width: 19.4%; 
  }
</style>
